import styled from 'styled-components';

export const StepCardTag = styled.article`
  position: relative;
  
  display: flex;
  flex-direction: column;
  min-height: 315px;
  padding: 25px;
  padding-top: 45px;
  
  color: ${({ theme }) => theme.black};
  
  background-color: ${({ theme }) => theme.white};
  box-shadow: 0 12px 48px 0 rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  
  overflow: hidden;
  
  &::before {
    content: "${({ number }) => number}";
    
    position: absolute;
    top: 0;
    left: 0;
    
    width: 40px;
    height: 40px;
    padding-top: 7px;
    padding-left: 12px;
    
    font-weight: 700;
    font-size: 18px;
    color: ${({ theme }) => theme.white};
    
    border-radius: 6px 0 50px 0;
    background-image: linear-gradient(135deg, #2DB9FE 0%, #4EDBFC 100%);
    box-shadow: 0 8px 20px 0 rgba(30,182,255,0.24);
  }
  
  @media(min-width: 700px) {
    flex-direction: row;
    align-items: flex-start;
    min-height: 190px;
    padding: 40px;
    padding-top: 50px;
  }
  
  @media(min-width: 1024px) {
    height: 100%;
    flex-direction: column;
    padding-top: 70px;
  }
`;

export const StepCardHeading = styled.h3`
  margin: 0;
  margin-bottom: 15px;
  padding: 0;
  
  font-size: 30px;
  line-height: 36px;
  
  @media(min-width: 700px) {
    max-width: 170px;
    flex-shrink: 0;
    margin-bottom: 0;
    margin-right: 40px;
    
    font-size: 36px;
    line-height: 40px;
  }
  
  @media(min-width: 1024px) {
    max-width: none;
    margin-bottom: 20px;
    margin-right: 0;
    
    font-size: 48px;
    line-height: 1;
  }
`;

export const StepCardDescription = styled.p`
  margin: 0;
  margin-bottom: auto;
  padding: 0;
  
  font-size: 16px;
  line-height: 22px;
  
  @media(min-width: 700px) {
    margin-top: 5px;
    margin-right: 30px;
    margin-bottom: 0;
  }
  
  @media(min-width: 1024px) {
    margin: 0;
    margin-bottom: auto;
    
    font-size: 16px;
    line-height: 22px;
  }
`;

export const StepCardButtonContainer = styled.div`
  flex-shrink: 0;
  
  button {
    width: 100%;
  }
  
  @media(min-width: 700px) {
    margin-left: auto;
    
    button {
      width: 155px;
    }
  }
  
  @media(min-width: 1024px) {
    margin-left: 0;
    
    button {
      width: auto;
      padding: 20px 30px;
    }
  }
`;
